import PropTypes from 'prop-types';
import Calculator from '@comp/Calculator/Calculator';

const Cal = ({ isScientific }) => <Calculator isScientific={isScientific} />;

Cal.Layout = ({ children }) => children;

Cal.getInitialProps = ({ query }) => {
  const { scientific } = query;
  const isScientific = scientific === 'true';
  return { isScientific };
};

Cal.pageInfo = {
  layoutOptions: {
    hideHeader: true,
    hideFooter: true,
    hideIntercom: true,
    hideFreshbot: true
  }
};

export default Cal;

Cal.propTypes = {
  isScientific: PropTypes.bool.isRequired
};
